import React, { useEffect } from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { Box, StyledEngineProvider, ThemeProvider, createTheme } from "@mui/material";
import CssBaseline from '@mui/material/CssBaseline'
import theme from './theme/theme';
import MainRoutes from './routing/MainRoutes';
import { ParallaxProvider } from 'react-scroll-parallax';
import GlobalMeta from './reusable/GlobalMeta';
import "@fontsource/metropolis";
import "@fontsource/metropolis/400.css";
import "@fontsource/metropolis/400-italic.css";

const App = () => {

  const fulltheme = createTheme(theme);
  //console.log(fulltheme);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={fulltheme}>
        <ParallaxProvider>
          <Box
            sx={{
              width: '100%',
              height: ' 100%',
            }}>
            <CssBaseline />
            <BrowserRouter>
              <MainRoutes />
            </BrowserRouter>
          </Box>
        </ParallaxProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};
export default App;
